__turbopack_context__.v({
  "footer": "K1TlGW_footer",
  "footer--nav-open": "K1TlGW_footer--nav-open",
  "footer__copyright": "K1TlGW_footer__copyright",
  "footer__navigation": "K1TlGW_footer__navigation",
  "footer__navigation__link": "K1TlGW_footer__navigation__link",
  "footer__wrapper": "K1TlGW_footer__wrapper",
});
